module.exports = __webpack_public_path__ + "img/arkel.ed36f006.png";